import { useEffect, useRef, useState } from "react";

import { Drawer, Stack } from "@mui/material";

import { useRestaurantContext } from "../../hooks/useRestaurantContext";
import { setStaffContext, trackStaffEvent } from "../../monitoring/mixpanel";
import { DishListing } from "../dish-listing";
import { MenuSelectionPage } from "../menu-selection-page/menu-selection-page";
import { StaffMenuBanner } from "../staff-menu-banner/staff-menu-banner";

interface WelcomePageProps {
  onSignOut: () => void;
}

export const WelcomePage = ({ onSignOut }: WelcomePageProps) => {
  const [filter, setFilter] = useState("");
  const [menuOpen, setMenuOpen] = useState(true);
  const { menu } = useRestaurantContext();
  const previousMenuId = useRef<string>();

  // Only signed-in staff reach this page, so opens before the PIN are not counted.
  useEffect(() => {
    // Picking the menu already shown reloads it; that is not a new open.
    if (!menu || menu.menuId === previousMenuId.current) return;
    setStaffContext({ menu_id: menu.menuId, menu_name: menu.menuName });
    trackStaffEvent("Menu Opened", {
      switched: previousMenuId.current !== undefined,
    });
    previousMenuId.current = menu.menuId;
  }, [menu?.menuId]);
  return (
    <>
      <Stack sx={{ minHeight: "100dvh" }}>
        <StaffMenuBanner
          filter={filter}
          onFilterChange={setFilter}
          onMenuOpen={() => setMenuOpen(true)}
          onSignOut={onSignOut}
        />

        <DishListing filter={filter} />
      </Stack>

      <Drawer
        open={menuOpen}
        anchor="bottom"
        PaperProps={{
          style: {
            height: "100%",
          },
        }}
        onClose={() => setMenuOpen(false)}
      >
        <MenuSelectionPage onClose={() => setMenuOpen(false)} />
      </Drawer>
    </>
  );
};
